import React from 'react';

import { getConfig } from '@zimpel/common/config';
import { GridCol } from '@zimpel/common/components/Grid';
import SupportInfo from './SupportInfo';
import LanguageSwitcher from './LanguageSwitcher/LanguageSwitcher';
import LogoWithTag from './Logo/LogoWithTag';
import LoggedOutNotificationContainer from './Notification/LoggedOutNotificationContainer';
import { HeaderCentered, HeaderWrapper } from './Layout/Header';

export const LoggedOutAppHeader = () => {
  const {
    deploymentTarget, theme, i18NLocale,
  } = getConfig();

  return (
    <HeaderWrapper>
      <HeaderCentered>
        <LogoWithTag environmentTag={deploymentTarget === 'int' ? null : deploymentTarget} />
        <GridCol $padLeft={1} $width={9}>
          <LoggedOutNotificationContainer offsetY={4} />
        </GridCol>
        <GridCol $padLeft={1} $width={3}>
          <LanguageSwitcher />
        </GridCol>
        <GridCol $padLeft={4} $width={2}>
          <SupportInfo theme={theme} locale={i18NLocale} loggedOut />
        </GridCol>
      </HeaderCentered>
    </HeaderWrapper>
  );
};

export default LoggedOutAppHeader;
